// Test IDs for the Wellth app (landing, intake, results, dashboard, share).

export const LANDING = {
	startButton: 'landing-start-button',
	shareButton: 'landing-share-button',
	loginLink: 'landing-login-link',
};

export const INTAKE = {
	ageInput: 'intake-age-input',
	heightInput: 'intake-height-input',
	weightInput: 'intake-weight-input',
	notesInput: 'intake-notes-input',
	nextButton: 'intake-next-button',
	backButton: 'intake-back-button',
	submitButton: 'intake-submit-button',
	issueChip: (slug) => `intake-issue-chip-${slug}`,
};

export const RESULTS = {
	container: 'results-container',
	shareButton: 'results-share-button',
	saveAccountButton: 'results-save-account-button',
	newReportButton: 'results-new-report-button',
	shopSupplementsLink: 'results-shop-supplements-link',
};

export const DASHBOARD = {
	container: 'dashboard-container',
	reportCard: 'dashboard-report-card',
	newReportButton: 'dashboard-new-report-button',
};

export const SHARE = {
	menuButton: 'share-menu-button',
	native: 'share-native',
	whatsapp: 'share-whatsapp',
	twitter: 'share-twitter',
	email: 'share-email',
	copyLink: 'share-copy-link',
};
